import React, { RefObject } from 'react';
import { BaseFilterSelect } from '../Shared/BaseFilterSelect';
import { components, MenuListProps } from 'react-select';
import useEventListener from '~/App/shared/hooks/useEventListener';
import { SliderFilterSelectProps, SliderOptionType } from '../types';
import { useSliderFilterSelect } from './useSliderFilterSelect';
import { SliderOption } from './SliderOption';

const MenuList = (props: MenuListProps<SliderOptionType, true>) => (
  <components.MenuList {...props}>
    {props.options.map((option: SliderOptionType) => (
      <SliderOption
        {...option}
        key={option.label}
        hideLabel={props.options.length === 1}
        onChange={props.selectProps.onChange}
        getSelectValue={props.getValue}
        selectedMainCategory={option.selectedMainCategory}
      />
    ))}
  </components.MenuList>
);

export const SliderFilterSelect = (props: SliderFilterSelectProps) => {
  const { options, onChange, name, ...propRest } = props;

  const { ref, isOpen, setIsOpen, handleChange, value } =
    useSliderFilterSelect(props);

  return (
    <div
      ref={ref}
      role="presentation"
      onMouseDown={() => setIsOpen(pre => !pre)}
      onTouchEnd={() => setIsOpen(pre => !pre)}
      onKeyDown={e => {
        if (e.key === 'ArrowDown') {
          setIsOpen(true);
        }

        if (e.key === 'Escape') {
          setIsOpen(false);
        }
      }}
    >
      <BaseFilterSelect<SliderOptionType, true>
        {...propRest}
        value={value || []}
        name={name}
        options={options}
        components={{
          MenuList
        }}
        onChange={handleChange}
        menuIsOpen={isOpen}
        onMenuOpen={() => setIsOpen(true)}
        toggleMenu={() => setIsOpen(pre => !pre)}
        openMenu={() => setIsOpen(true)}
        closeMenu={() => setIsOpen(false)}
      />
    </div>
  );
};

export function useOnClickOutside<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: (event: MouseEvent | TouchEvent) => void,
  mouseEvent: 'mousedown' | 'mouseup' = 'mousedown'
): void {
  useEventListener(mouseEvent, event => {
    const el = ref?.current;

    // Do nothing if clicking ref's element or descendent elements
    if (!el || el.contains(event.target as Node)) {
      return;
    }

    handler(event);
  });
}
